import cn from 'classnames';
import { Label } from '#components/atoms/forms/index.ts';
import { useGuaranteedId } from '#hooks/useGuaranteedId.ts';
import { useRadioGroup } from './useRadioGroup.ts';
import styles from './RadioCard.module.css';

type Props = Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'value'> & {
  children: React.ReactNode;
  value: string | number;
  className?: string;
};

export function RadioCard({ id, value, children, className, ...inputProps }: Props) {
  const { name, selectedValue, onChange } = useRadioGroup();
  const inputId = useGuaranteedId({ prefix: 'radio', id });

  return (
    <div className={styles.RadioCard}>
      <input
        className={cn('visually-hidden', styles.RadioCard_input)}
        id={inputId}
        name={name}
        type="radio"
        value={value}
        checked={selectedValue ? selectedValue === value : undefined}
        onChange={onChange}
        {...inputProps}
      />
      <Label htmlFor={inputId} className={cn(className, styles.RadioCard_label)}>
        {children}
      </Label>
    </div>
  );
}
